<template>
  <div class="vx-row">
    <vx-card v-if="powerBiReportEmbed.length != 0">
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <!-- <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button> -->
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <!-- <h3>{{ campaign_status }} Campaigns</h3> -->
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <template v-for="(report,index) in powerBiReportEmbed">


        <div class="text-center">
          <h5>{{report.dashboard_name}}</h5>
          <vs-icon icon="fullscreen" @click="toggle(index)" size="small" class="full_screen_mode"
              ></vs-icon
            >
          <!-- <button type="button" @click="toggle(index)" >Fullscreen</button> -->
        </div>
        
        
            
        <div>
          <fullscreen ref="fullscreen_mode" :fullscreen.sync="fullscreen">
            <PowerBIReportEmbed :embedConfig=report :cssClassName=embed_report_css>
            </PowerBIReportEmbed>
        </fullscreen>

        </div>

        <vs-divider class="mb-10 mt-10" />

      </template>

    </vx-card>

    <!-- <vx-card v-else>
      <div class="text-center">
        <h5>No Dashboard Selected</h5>
      </div>

    </vx-card> -->

  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import { PowerBIReportEmbed } from 'powerbi-client-vue-js';
import fullscreen from 'vue-fullscreen'
import Vue from 'vue'
Vue.use(fullscreen)
export default {
  data: () => ({
    authorized:true,
    fullscreen: false,
    embed_report_css: 'embed_report_css',
    embed_token: null,
    campaign_power_bi_dashboard: [],
    campaignDescription: {},
    // embedConfig: {
    //   type: "report",
    //   id: "3ac5b0ba-e3bd-45b6-a0c2-090edc9714ec",
    //   embedUrl: "https://app.powerbi.com/reportEmbed?reportId=3ac5b0ba-e3bd-45b6-a0c2-090edc9714ec&groupId=e8cce3e2-1b2d-4bc6-b61f-cc29ffff8c61&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVLLVNPVVRILXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwidXNhZ2VNZXRyaWNzVk5leHQiOnRydWUsInNraXBRdWVyeURhdGFTYWFTRW1iZWQiOnRydWUsInNraXBRdWVyeURhdGFQYWFTRW1iZWQiOnRydWUsInNraXBRdWVyeURhdGFFeHBvcnRUbyI6dHJ1ZX19",
    //   accessToken: "H4sIAAAAAAAEACXTt66EVgAE0H95LZbIyZILYMmwZFjoCJec44Llf_ez3E91ZubvHzu9-yktfv78OYqQQUm07rVRuSk119TdbM_OHUMJfYTwVkqARcMqrtrNVxkGOlQVHvDpPHpO7fiRlwAbd4myl3ieky9caoX1jYo3NqGZc3rlx4Htg5MPh5usXkZByvh6LPsyzGjmdY_zO-HgdyEe8HSYK4WgIimsyNwfFHc9FLl_fI35PDHjYegJWXWkVfbSRMzR-nYmmjw9BPhH4JsiQcMJ08QeHdvU-BxO5OpbHBCNGiCNhC-RRfMF7iRV4TK9AwfkyOaHrxnkTUfX6LphbYc0srvrwxZdQ8PULWph-3rI2i65LmB26yrItnpcj_0mZfIGDhrX5zUp3WjMehTycXw5fMxlm9z1wDPyKMjvwHqw7xfHK0fqSAgPuZI7FYH53PPXGZtkBd7FzqdBY6D6RO_YoSvBGawIGa2X5jVuOrh36Cwm7H10sDISdI8-QlmBasxppbTuikHe12su-9RFv-zlFmBZGZW4GhYNf-uQe8gCXaUNuKGDrCfSkXZb3thx9GUwWmvrGYvG4Bl1XVf-MpE7Zxs7V6StGLSo5NWMwDNmPG88zPhFwtsFLd1R2odfFu_FCxs8RMYJmS38UuKNaDaQhp6k2-rumyRAUmAt-qPEYTCGalSOfZuHz7dYnsGEplPevz0mIeiah6twwcceZ2hwLzLZnDqxCnZmzK9tSxN5INAXP0vblJ1Jby-4QBiq--KWiIKbDvfhFBIysXr7_NuJA7LSCGy57whXqr_--vnjR1jveZ90cP838wgzNmiwBoiHT7Z1oqBMcGJgLddXObOGcO24Y5JyHQ2dFLLaHWbQa1YZymMm3ktMmvVp-5zj3waQPPcCluRFhOCIlhErJO4ZZjB1tBCINMz2i5t-9bp8Ta2JeJUunu_TIqfyNW9hs6dqF-2IwU_T82WorNHeLIWwy2UlQ3i8W_yjI8DcPi0BipqvgeTiwKrIF7WwcZMtwbDJIyG9avgxULFG2f5yzM8QQYULz3F69IaWiVlfY5oaQq622jHUoOi1RdcLg_TNwwjFviqwo_Tky981z12ZCPT8pl1zyue7sXLf3RTqwRCHR7KZoV-iM1-Rzgk5LiX5fKBZ-57yCUWowcav_5nvuQarGv4qc5w5vQgaiXovHxN6OI0xWf8vw2uqMd2PFfzGdFF-MBUjA6O7ibuR2xUrKmWXyyteX_HChSRov1bMULJylfckkBMfMxN10kNKG-RjBdVbNBv5xM8o5p8g0HiB1-NO5pBMjD7j0qFkMwx3x2YbhmZjF7zdkqfyPBEhOSp8nl8VQwCyYLWziFzHUYgGEEOY9vU5O_OD3msd7NJGt0C8GYXyOy-Fa45TI_7oHsYcWXMXlqSCu9eMaIQAetQ1Ggd6v0V8S0U7cPjL2AN_xCH8abpPJba951PKXjc2i0siUn_1ATJVDq3J348U0OKp_I3lW4UCqHl4ZTk7YM_Rmc8yVLaKLCWh8Zazhd0zKikGv_X6dlZAJ5VEtiW-fDCgHrlf5n_-BRRlzaXaBQAA.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVLLVNPVVRILXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZXhwIjoxNjY5ODI2Nzk5fQ==",
    //   tokenType: 1,
    //   hostname: "https://app.powerbi.com"
    // },
    powerBiReportEmbed: [],
    user_id: null,
    user_role: null,
    campaign_status: null,
    abilities: null,
    campaign_id: null
  }),
  components: {
    "v-select": vSelect,
    PowerBIReportEmbed
  },
  watch: {},
  methods: {
    toggle (index) {
      this.$refs['fullscreen_mode'][index].toggle()
      },
    getPowerBIEmbedToken() {
      let self = this
      // this.$vs.loading();
      let data = {}
      data.campaign_power_bi_dashboard = self.campaign_power_bi_dashboard
      data.campaign_id = self.campaignId
      data.user_id = self.user_id
      self.$store
        .dispatch("campaignsManagement/getPowerBIEmbedToken", data)
        .then(res => {
          let response = res.data
          this.embed_token = response
          if (this.embed_token) {

            this.embed_token.forEach(function (e, i) {
              self.campaign_power_bi_dashboard.forEach(function (ele, index) {
                if (i == index) {
                  self.powerBiReportEmbed.push({
                    type: "report",
                    id: ele.power_bi_dashboard_id,
                    embedUrl: ele.power_bi_embed_url,
                    accessToken: e,
                    tokenType: 1,
                    hostname: "https://app.powerbi.com",
                    dashboard_name : ele.name,
                    settings: {
                              panes: {
                                  filters: {
                                      expanded: false,
                                      visible: false
                                  }
                              },
                          },
                          pageView: "fitToWidth"

                  })

                }


              })

            })

          }

          self.$vs.loading.close();

        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })


      // insert to db



    },
    checkClientUserCampaignPermission() {
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/checkClientUserCampaignPermission" , data)
        .then(res => {
          let result = JSON.parse(res.data)
          if (result.length == 0){
            this.authorized = false
            this.$router.replace("/unauthorized")
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCampaignDescription() {
      let self = this
      self.$vs.loading();
      const campaignId = this.$route.params.campaignId;
      self.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          self.campaignDescription = res.data;
          if (self.campaignDescription) {
            let newArray = []
            self.campaign_power_bi_dashboard = self.campaignDescription.campaign_power_bi_dashboard
            self.campaign_power_bi_dashboard.forEach(function(e){
              if(e.permission){
                e.permission.forEach(function(ele){
                  
                  if(ele.uuid == self.user_id){
                    newArray.push(e)
                  }
              })
            }

            })

            const arrayUniqueByKey = [...new Map(newArray.map(item =>[item['power_bi_dashboard_name'], item])).values()];

            self.campaign_power_bi_dashboard = arrayUniqueByKey

            

            self.getPowerBIEmbedToken()


          }

        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },


    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
  },
  mounted() {
    if(this.authorized){
      this.getCampaignDescription()
    }

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });


    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    self.campaign_id = this.$route.params.campaignId

    // if (this.user_role != 'Client Administrator' && this.user_role != 'Client'){
    //   this.authorized = false
    //   this.$router.replace("/unauthorized")
    // }

    if (this.user_role == 'Sales Developer'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }


    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    this.checkClientUserCampaignPermission()

  }
};
</script>
<style>
.embed_report_css {
  height: 800px;
}

.full_screen_mode{
  cursor: pointer;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
